import { useEffect } from 'react';
import { Logger } from 'simple-logging-lib';
import { useAppSelector } from '../../../hooks';
import { selectCurrentTrials, selectCurrentTrialsStatus } from '../../../selectors';
import { useExperiments } from '../../../hooks/useNavConfig';
import { getExperimentGroup } from '../../../laboratory';
import { RequestStatus } from '../../../interface';
import { MINI_TRIAL_GUIDE_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { getMiniTrialGuideOpenFromStorage, setMiniTrialGuideState } from '../../../external-contrib/growth-trials/utils/localStorage';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
export const useMiniTrialGuide = () => {
  const {
    toggle: delayedToggle
  } = useToggleComponent(MINI_TRIAL_GUIDE_COMPONENT, {
    useScheduler: true
  });
  const trials = useAppSelector(selectCurrentTrials);
  const trialsStatus = useAppSelector(selectCurrentTrialsStatus);
  const experiments = useExperiments();
  const experimentGroup = getExperimentGroup('hc-0134', experiments);
  const shouldRenderMiniTrialGuide = trialsStatus === RequestStatus.SUCCESS && trials.length > 0 &&
  // Change experimentGroup to 'control' to see the mini trial guide
  experimentGroup === 'variation';
  useEffect(() => {
    if (trialsStatus === RequestStatus.SUCCESS) {
      try {
        const isOpen = getMiniTrialGuideOpenFromStorage();
        if (shouldRenderMiniTrialGuide && isOpen) {
          delayedToggle(true);
        } else {
          setMiniTrialGuideState(false);
        }
      } catch (error) {
        setMiniTrialGuideState(false);
        const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
        logger.error(new Error('Error rendering mini trial guide', {
          cause: error
        }));
      }
    }
  }, [shouldRenderMiniTrialGuide, trialsStatus, delayedToggle]);
  return shouldRenderMiniTrialGuide;
};